/**
 * Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UserStatisticsResponse { 
    date: string;
    avgDailyHashrate: number;
    totalMiningReward: number;
    totalReferralReward: number;
}

